import { T } from "../app/tokens.js";
import { CalculatedDateLabel } from "./CalculatedDateLabel.jsx";

const one = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 };
export function UpcomingEventRow({ tag, label, subline, date, event, first, urgent = false, testId = "lac-ahead-row" }) {
  const type = String(tag).toLowerCase();
  const tone = type === "decision" ? { background: T.chipDecisionBg, color: T.chipDecisionFg }
    : type === "expiry" ? { background: T.chipExpiryBg, color: T.ragRed }
    : { background: T.blueSoft, color: T.blue };
  const qualified = ["calculated", "ambiguous"].includes(event?.provenance);
  const full = [label, subline, qualified ? event.disclosure : null].filter(Boolean).join(" · ");
  return <div data-testid={testId} style={{ display: "grid", gridTemplateColumns: "86px minmax(0,1fr) 112px",
    columnGap: 12, alignItems: "center", padding: "9px 0", fontSize: T.fsSm,
    borderTop: first ? undefined : `1px solid ${T.hair}` }}>
    <span data-event-column="pill" style={{ ...tone, ...one, width: 86, boxSizing: "border-box", padding: "2px 0", textAlign: "center",
      fontSize: T.fsXxs, fontWeight: T.fwBold, letterSpacing: ".04em", textTransform: "uppercase", borderRadius: 5 }}>{tag}</span>
    <div data-event-column="text" title={full} tabIndex={0} style={{ ...one, fontWeight: T.fwSemibold, color: T.dark }}>
      <div style={one}>{label}</div>
      {(subline || qualified) && <div style={{ ...one, color: T.mid, fontSize: T.fsXs, fontWeight: T.fwRegular }}>
        <CalculatedDateLabel event={event} />{qualified ? ` · ${event.provenance === "ambiguous" ? `${label} · source unverified` : "calculated"}` : ""}{subline && qualified ? " · " : ""}{subline}
      </div>}
    </div>
    <span data-event-column="date" data-testid="lac-ahead-date" title={date} style={{ ...one, textAlign: "right",
      fontVariantNumeric: "tabular-nums", fontWeight: T.fwSemibold, color: urgent ? T.ragRed : T.mid }}>{date}</span>
  </div>;
}
